import { dropdownTriggerClassname } from "app/components/Dropdown";
import { UserIcon } from "app/components/Icons";
import MemberProfileAvatar from "app/components/MemberProfileAvatar";
import CustomTooltip from "app/components/Tooltip";
import MemberSelection from "app/containers/Features/components/MemberSelection";
import { filterActiveTeamMembers } from "app/containers/Features/components/MemberSelection/helper";
import { selectProjectMemberList } from "app/containers/Features/components/MemberSelection/redux/selector";
import {
  IMemberList
} from "app/containers/Features/components/MemberSelection/types";
import clsx from "clsx";
import React from "react";
import { useSelector } from "react-redux";

interface CustomProps {
  assignedTo: string;
  onOpen: () => void;
  onClose: () => void;
  projectId: string;
  onUpdate: (value: string) => void;
}

const SelectAssignee: React.FC<CustomProps> = ({
  assignedTo,
  onClose,
  onOpen,
  onUpdate,
  projectId,
}) => {
  const members = useSelector(selectProjectMemberList);
  const activeMembers = filterActiveTeamMembers(members);

  const updateValue = (data: IMemberList) => {
    onUpdate(data._id);
  };

  return (
    <MemberSelection
      trigger={
        <button
          className={clsx(
            "flex items-center justify-between w-full p-[6px] rounded-md outline-none",
            dropdownTriggerClassname,
          )}
        >
          <CustomTooltip
            text="Click to choose assignee"
            className="flex items-center gap-1 "
            position="left"
          >
            {assignedTo ? (
              <div className="flex items-center gap-2">
                <UserIcon size={16} />
                <MemberProfileAvatar
                  id={assignedTo}
                  circleClassName=" text-[6.4px] leading-[19.2px] font-normal !size-[18px]"
                  statusClassName="size-[3px]"
                />
              </div>
            ) : (
              <span className="text-xs leading-[18px] font-normal text-secondary ">
                Choose assignee
              </span>
            )}
          </CustomTooltip>
        </button>
      }
      selectedValue={assignedTo}
      updateValue={updateValue}
      align="center"
      searchPlaceholder="Search by assignee or role "
      onClose={onClose}
      onOpen={onOpen}
      headingText="Assignees"
      options={activeMembers}
    />
  );
};

export default SelectAssignee;
